<template>
  <div class="overseas_order_list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="70px">
        <!-- 配件代码 -->
        <el-form-item label="配件代码">
          <el-input
            v-model="queryParams.partCode"
            placeholder="请输入配件代码"
          ></el-input>
        </el-form-item>
        <!-- 配件名称 -->
        <el-form-item label="配件名称">
          <el-input
            v-model="queryParams.partName"
            placeholder="请输入配件名称"
          ></el-input>
        </el-form-item>

        <!-- 操作 -->
 
          <el-button type="primary"  @click="doSearch"
            >查询</el-button
          >
          <el-button type="primary" plain @click="handleResetQuery"
            >重置</el-button
          >
     
      </el-form>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <div class="table-btn" >
        <el-button
          type="text"
          icon="el-icon-upload2"
          @click="openMB"
          >导入</el-button
        >
        <!-- :loading="exportLoading" -->
        <el-button
          type="text"
          @click="downMB"
          icon="el-icon-download"
          >导出</el-button
        >
      </div>
      <!-- v-loading="tableLoading" -->
      <el-table
        ref="tableRef"
        highlight-current-row
        border
        stripe
        :data="tableData"
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ getColumnIndex(scope.$index) }}
            </span>
          </template>
        </el-table-column>
        <!-- 配件代码 -->
        <el-table-column
          prop="partCode"
          label="配件代码"
          :min-width="$getColumnWidth('partCode', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ scope.row.partCode }}
            </span>
          </template>
        </el-table-column>
        <!-- 配件名称 -->
        <el-table-column
          prop="partName"
          label="配件名称"
          :min-width="$getColumnWidth('partName', tableData)"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ scope.row.partName }}
            </span>
          </template>
        </el-table-column>
        <!-- 供应商代码 -->
        <el-table-column
          prop="supplierCode"
          label="供应商代码"
          :min-width="$getColumnWidth('supplierCode', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ scope.row.supplierCode }}
            </span>
          </template>
        </el-table-column>
        <!-- 供应商名称 -->
        <el-table-column
          prop="supplierName"
          label="供应商名称"
          :min-width="$getColumnWidth('supplierName', tableData)"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ scope.row.supplierName }}
            </span>
          </template>
        </el-table-column>
        <!-- 采购价 -->
        <el-table-column
          prop="purchasePrice"
          label="采购价"
          :min-width="$getColumnWidth('purchasePrice', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ scope.row.purchasePrice }}
            </span>
          </template>
        </el-table-column>
        <!-- 月份 -->
        <el-table-column
          prop="yearsMonth"
          label="月份"
          :min-width="$getColumnWidth('yearsMonth', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ scope.row.yearsMonth }}
            </span>
          </template>
        </el-table-column>
        <!-- 客户国家 -->
        <el-table-column
          prop="updateName"
          label="更新人员"
          :min-width="$getColumnWidth('updateName', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ scope.row.updateName }}
            </span>
          </template>
        </el-table-column>
        <!-- 发运时间 -->
        <el-table-column
          prop="updateTime"
          label="更新时间"
          :min-width="$getColumnWidth('updateTime', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
              {{ scope.row.updateTime.replace("T", " ") }}
            </span>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column
          label="操作"
          align="center"
          width="190px"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 编辑 -->
            <el-button
              type="text"
              @click="openOldListModal(scope.row)"
              >历史价格</el-button
            >
            <el-button type="text" @click="openModal(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" @click="deleteList(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="导入" :visible.sync="dialogVisible">
      <!-- url -->
      <!--  禁用自动上传  -->
      <!-- 上传前的限制 -->
      <!-- 最多上传 1 个文件 -->
      <!-- 当前文件列表 -->
      <!-- 只接受 xls 和 xlsx 格式 -->
      <!-- 超过限制时的处理 -->
      <!-- 监听上传成功事件 -->
      <el-upload
        ref="upload"
        :headers="header"
        :action="imAction"
        :auto-upload="false"
        :before-upload="beforeUpload"
        :limit="1"
        :file-list="fileList"
        accept=".xls,.xlsx"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
        :on-change="handleChange"
        :on-success="handleSuccess"
      >
        <el-button size="small" type="primary">选取附件</el-button>
      </el-upload>
      <p style="margin-top: 5px">
        只能上传 xls,xlsx 格式，文件大小不超过5M,最多上传1个文件
      </p>
      <!-- 底部按钮 -->
      <div slot="footer" class="divf">
        <el-button type="primary" @click="getMB">下载模板</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="postMB"
          >导入</el-button
        >
        <el-button @click="closeMB">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 引入 ModalForm 组件 -->
    <ModalForm
      :visible="modalVisible"
      :data="dialogData"
      @update:visible="modalVisible = $event"
      @submit="handleModalSubmit"
    />
    <!-- 引入 历史数据列表 组件 -->
    <parts-list-dialog
      :visible.sync="modalVisibleList"
      :queryParams="dialogDataList"
    />
  </div>
</template>

<script>
import { getDownloadFiles } from "@/util/downFile";
import ModalForm from "./components/costdialoglist.vue"; // 导入弹窗组件
import PartsListDialog from "./components/costdialoglists.vue"; // 导入弹窗组件
import listCurd from "@/mixins/listCurd";
import {
  getCostPriceMaintenance,
  postCostPriceMaintenanceR,
  postCostPriceMaintenanceC,
  postCostPriceMaintenance,
  editCostPriceMaintenance,
  deleteCostPriceMaintenance,
  oldCostPriceMaintenance
} from "@/api/cost.js";
import { getDictItem } from "@/util/dict";
import { uploadUrl } from "@/util/url";

export default {
  components: { ModalForm, PartsListDialog },
  mixins: [listCurd],
  data() {
    return {
      // exportLoading: false, //加载
      header: {
        satoken: sessionStorage.getItem("token")
      },
      imAction:
        uploadUrl +
        "/manage/gysPriceFillOut/importCostPriceMaintenanceTemplateExcel",
      // imAction:
      //   "http://192.168.121.18:8082/manage/gysPriceFillOut/importCostPriceMaintenanceTemplateExcel",
      fileList: [], // 当前上传的文件列表
      //按钮
      isDisabled: true,
      // 弹窗
      dialogVisible: false,
      modalVisible: false,
      modalVisibleList: false,
      //编辑内容
      dialogData: {},
      //历史内容
      dialogDataList: {},
      // 车型
      carTypeList: [],
      // 发运方式
      deliveryMethodList: [],
      // 查询参数
      queryParams: {
        partCode: "",
        partName: ""
      },
      // 表格数据
      listMethod: postCostPriceMaintenance
    };
  },
  watch: {
    // 监听 fileList 数组的变化
    fileList(newValue) {
      // 如果数组为空，禁用按钮；否则启用按钮
      this.isDisabled = newValue.length === 0;
    },
    //导入弹窗关闭后刷新
    dialogVisible(newValue) {
      if (!newValue) return this.doSearch();
    }
  },
  created() {
    this.doSearch();
  },
  methods: {
    //打开导入弹窗
    openMB() {
      this.dialogVisible = true;
      this.fileList = [];
    },
    //关闭导入弹窗
    closeMB() {
      this.dialogVisible = false;
      this.fileList = [];
    },
    //下载模板
    getMB() {
      // this.exportLoading = true;
      getCostPriceMaintenance().then(response => {
        getDownloadFiles(response);
        if (response.fileName) {
          this.$DonMessage.success("下载成功！");
        }
        // this.exportLoading = false;
      });
    },
    downMB() {
      // this.exportLoading = true;
      const updata = {
        data: this.queryParams
      };
      postCostPriceMaintenanceC(updata).then(response => {
        getDownloadFiles(response);
        if (response.fileName) {
          this.$DonMessage.success("导出成功！");
        }
        // this.exportLoading = false;
      });
    },
    postMB() {
      // 通过 ref 获取 el-upload 实例，手动触发上传
      this.$refs.upload.submit();
      //自定义接口上传
      // const fileList = this.$refs.upload.uploadFiles; // 获取文件列表
      // if (fileList.length === 0) {
      //   this.$DonMessage.warning("请选择文件后再上传！");
      //   return;
      // }

      // // 创建 FormData 实例来构造文件上传的请求数据
      // const formData = new FormData();
      // formData.append("file", fileList[0].raw); // 获取选择的文件

      // // 使用 axios 上传文件
      // postCostPriceMaintenanceR(formData)
      //   .then((res) => {
      //       this.$DonMessage.success("文件上传成功!");
      //   })
      //   .catch((error) => {
      //     this.$DonMessage.error("文件上传失败!");
      //     console.error(error);
      //   });
    },
    handleRemove(file, fileList) {
      this.fileList = [...fileList]; // 更新 fileList，避免修改原数组
    },
    handleChange(file, fileList) {
      this.fileList = fileList; // 手动更新 fileList
    },
    // 上传成功后的回调函数
    handleSuccess(response, file, fileList) {
      // 根据返回的结果进行处理
      if (response && response.status == 0) {
        this.doSearch();
        this.$DonMessage.success("导入文件成功！"); // 使用 Element Plus 提示框
      } else {
        this.$DonMessage.error(response.message); // 使用 Element Plus 提示框
      }
      this.fileList = []; // 当前上传的文件列表
    },
    // 文件上传前的验证
    beforeUpload(file) {
      const isExcel = file.name.endsWith(".xls") || file.name.endsWith(".xlsx");
      if (!isExcel) {
        this.$DonMessage.warning("只能上传 xls 或 xlsx 格式的文件");
        return false; // 阻止上传
      }
      const isSmallEnough = file.size / 1024 / 1024 < 5; // 转换为MB并判断
      if (!isSmallEnough) {
        this.$DonMessage.warning("文件大小不能超过 5MB");
        return false; // 阻止上传
      }
      return true; // 通过验证，允许上传
    },
    // 文件数量超出时的处理
    handleExceed(files, fileList) {
      this.$DonMessage.warning("只能上传一个文件");
    },
    //历史弹窗
    openOldListModal(obj) {
      this.dialogDataList.pid = obj.id;
      this.modalVisibleList = true; // 打开弹窗
    },
    //编辑弹窗
    openModal(obj) {
      this.dialogData = JSON.parse(JSON.stringify(obj));
      this.modalVisible = true; // 打开弹窗
    },

    //提交编辑
    handleModalSubmit(data) {
      let updata = {
        id: data.id,
        partCode: data.partCode,
        partName: data.partName,
        supplierName: data.supplierName,
        purchasePrice: data.purchasePrice
      };
      editCostPriceMaintenance(updata).then(res => {
        if (res.status == 0) {
          this.$DonMessage.success(res.message);
        } else {
          this.$DonMessage.error(res.message);
        }
        this.doSearch();
        updata = null;
      });

      // 在这里处理表单提交的数据
    },

    //删除列表
    deleteList(obj) {
      this.$confirm(`确认删除该成本价吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(async () => {
          let updata = {
            id: obj.id,
            partCode: obj.partCode,
            partName: obj.partName,
            supplierName: obj.supplierName
          };
          deleteCostPriceMaintenance(updata).then(res => {
            if (res.status == 0) {
              this.$DonMessage.success(res.message);
            } else {
              this.$DonMessage.error(res.message);
            }
            this.doSearch();
            updata = null;
          });
        })
        .catch(() => {});
    },

    
    // 获取车型列表
    async getCarTypeList() {
      const carTypeList = await getDictItem("carType");
      carTypeList.map(item => {
        this.carTypeList.push({ text: item.value, value: item.code });
      });
    },
    // 获取发运方式
    async getDeliveryMethodList() {
      this.deliveryMethodList = [];
      const deliveryMethodList = await getDictItem("deliveryMethod");
      deliveryMethodList.map(item => {
        this.deliveryMethodList.push({
          text: item.value,
          value: item.code
        });
      });
    },
    // 打开订单对话框
    handleAddOrEdit(title, data) {
      this.$refs.orderDialog.init(title, data);
    },
    // 实销数据上报
    handleSaleData(title) {
      this.$refs.saleDataDialog.init();
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.divf {
  margin-left: 30%;
  width: 40%;
  display: flex;
  justify-content: space-between;

  padding: 30px 0;
}
.ischaoQi {
  color: red;
}
</style>
